import {useCallback} from "react";
import {trackMixpanel} from "../utils/mixpanel.ts";
import {BalloonEventModel} from "ts-core";

export interface EventClickProps {
    event: BalloonEventModel;
}

export const useEventClick = (event: BalloonEventModel, onClick: () => void, source: 'tile' | 'list' = 'tile') => {
    const handleClick = useCallback(() => {
        trackMixpanel("EventTile", "Click", {
            eventId: event.id,
            eventName: event.title,
            source,
        });
        onClick();
    }, [event.id, event.title, source, onClick]);

    return {handleClick};
};